export default __webpack_public_path__ + "static/media/ab7.cfcf3b84.jpg";